export default __webpack_public_path__ + "static/media/Ionicons.9b6b1954.ttf";